import styled from 'styled-components';

const BoxWithMargin = styled.div`
  margin-top: ${({ desktop }) => (desktop.top ? desktop.top : 0)}
  margin-bottom: ${({ desktop }) => (desktop.bottom ? desktop.bottom : 0)}
  margin-right: ${({ desktop }) => (desktop.right ? desktop.right : 0)}
  margin-left: ${({ desktop }) => (desktop.left ? desktop.left : 0)}

 
  @media screen and (max-width: ${({ breakpoint }) => breakpoint || '767px'}){
    margin-top: ${props => (props.responsive.top ? props.responsive.top : 0)}
    margin-bottom: ${props => (props.responsive.bottom ? props.responsive.bottom : 0)}
    margin-right: ${props => (props.responsive.right ? props.responsive.right : 0)}
    margin-left: ${props => (props.responsive.left ? props.responsive.left : 0)}
    
    width: ${({ responsiveWidth }) => responsiveWidth || 'auto'}; 
  }

  width: ${({ desktopWidth }) => desktopWidth || 'auto'};
  word-break: break-word;
  
`;

BoxWithMargin.defaultProps = {
  desktop: {
    top: '0px',
    bottom: '0px',
  },
  responsive: {
    top: '0px',
    bottom: '0px',
  },
};

export default BoxWithMargin;
